// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WXQoi","rootParamsCollapsed":"styles_rootParamsCollapsed__34Jjl","rootPreviewFull":"styles_rootPreviewFull__1_jFP","loader":"styles_loader__i2BRj"};